// extracted by mini-css-extract-plugin
export var iwtContainer = "iwt-module--iwtContainer--287c6";
export var text = "iwt-module--text--d59bf";